import styled from '@emotion/styled/macro';
import rem from '../../utils/rem/rem';
import { Container } from '../Checkbox/Checkbox.styles';
import { StyledProps } from './MenuTreeView.types';
import { css } from '@emotion/react';

export const StyledTreeViewContainer = styled.div<StyledProps>`
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: ${({ borderRadius }) => `${borderRadius === undefined ? 0 : borderRadius}px`};
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: ${({ height }) => height || '82%'};

  div:nth-of-type(even):not(${Container}) {
    background-color: ${({ theme }) => theme.colors.white};

    &:hover {
      background-color: ${({ theme }) => theme.colors.blueOpacity10};
    }
  }
`;

export const Row = styled.div<StyledProps>`
  display: flex;
  height: ${rem(50)};
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: ${rem(16)} 0;
  padding-left: ${({ level }) => `${level === 1 || level === undefined ? 8 : (level - 1) * 68}px`};
  border-bottom: 1px solid ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.gray100};
  cursor: pointer;
  scroll-behavior: smooth;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blueOpacity10};
  }

  &:focus {
    outline: 1px solid ${({ theme }) => theme.colors.blue};
    outline-offset: -1px;
  }

  a {
    display: inline;
  }
  
  ${({ highLighted }) => {
    if (highLighted) {
      // double ampersand denotes CSS priority
      return css`
        &&&& {
            background-color: rgba(38, 109, 204, 0.18);
        }
      `
    }
  }}

  
`;

export const RowLabel = styled.label<StyledProps>`
  font-family: 'Open Sans';
  font-weight: ${({ expanded }) => (expanded ? 700 : 400)};
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.gray900};
  display: flex;
`;
